/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Reset Password with Token Request Body
 * @export
 * @interface ResetPasswordWithTokenRequest
 */
export interface ResetPasswordWithTokenRequest {
    /**
     * Password
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    password: string;
    /**
     * Token
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    token: string;
    /**
     * Retrieve Device Keys
     * @type {boolean}
     * @memberof ResetPasswordWithTokenRequest
     */
    retrieveDeviceKeys?: boolean;
    /**
     * reCAPTCHA Token
     * @type {string}
     * @memberof ResetPasswordWithTokenRequest
     */
    recaptchaToken: string;
}

/**
 * Check if a given object implements the ResetPasswordWithTokenRequest interface.
 */
export function instanceOfResetPasswordWithTokenRequest(value: object): value is ResetPasswordWithTokenRequest {
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('recaptchaToken' in value) || value['recaptchaToken'] === undefined) return false;
    return true;
}

export function ResetPasswordWithTokenRequestFromJSON(json: any): ResetPasswordWithTokenRequest {
    return ResetPasswordWithTokenRequestFromJSONTyped(json, false);
}

export function ResetPasswordWithTokenRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordWithTokenRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'password': json['password'],
        'token': json['token'],
        'retrieveDeviceKeys': json['retrieve_device_keys'] == null ? undefined : json['retrieve_device_keys'],
        'recaptchaToken': json['recaptcha_token'],
    };
}

export function ResetPasswordWithTokenRequestToJSON(value?: ResetPasswordWithTokenRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'password': value['password'],
        'token': value['token'],
        'retrieve_device_keys': value['retrieveDeviceKeys'],
        'recaptcha_token': value['recaptchaToken'],
    };
}

